import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

let pending;
let generation = 0;
const originalInert = new WeakMap();
let colorGeneration = 0;

document.addEventListener(StandardEvents.productSelect, async (event) => {
  const picker = event.target.closest?.('variant-picker');
  if (!picker || picker.closest('product-card, quick-add-dialog')) return;
  const packages = picker.closest('main')?.querySelector('.clendo-packages');
  if (!packages) return;
  const version = ++colorGeneration;
  pending?.abort();
  packages.inert = true;
  packages.setAttribute('aria-busy', 'true');
  try {
    const { detail } = await event.promise;
    if (version !== colorGeneration || !packages.isConnected) return;
    const replacement = detail?.html?.querySelector('.clendo-packages');
    if (replacement) morph(packages, replacement);
  } catch (error) {
    if (error.name !== 'AbortError' && version === colorGeneration) location.reload();
  } finally {
    if (version === colorGeneration) {
      packages.inert = false;
      packages.removeAttribute('aria-busy');
    }
  }
});

document.addEventListener('click', async (event) => {
  const link = event.target.closest?.('.clendo-packages__option');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const url = new URL(link.href, location.href);
  const main = link.closest('main');
  if (!main || url.origin !== location.origin) return;
  event.preventDefault();
  if (link.getAttribute('aria-current') === 'page' && !pending) return;
  pending?.abort();
  const controller = new AbortController();
  pending = controller;
  const request = ++generation;
  const forms = [...main.querySelectorAll('product-form-component, sticky-add-to-cart')];
  const previousInert = forms.map((form) => {
    if (!originalInert.has(form)) originalInert.set(form, form.inert);
    return originalInert.get(form);
  });
  forms.forEach((form) => { form.inert = true; });
  main.setAttribute('aria-busy', 'true');
  const preview = new URL(location.href).searchParams.get('preview_theme_id');
  if (preview) url.searchParams.set('preview_theme_id', preview);
  try {
    const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Product response unavailable');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const nextMain = html.querySelector('main');
    if (!nextMain?.querySelector('.clendo-packages__option[aria-current="page"]')) throw new Error('Product selection missing');
    if (request !== generation) return;
    pending = null;
    forms.forEach((form, index) => { form.inert = previousInert[index]; });
    morph(main, nextMain);
    document.title = html.title;
    for (const selector of ['link[rel="canonical"]', 'meta[name="description"]']) {
      const current = document.head.querySelector(selector);
      const replacement = html.head.querySelector(selector);
      if (current && replacement) current.replaceWith(replacement);
    }
    history.pushState({ clendoPackage: true }, '', url);
    const selected = main.querySelector('.clendo-packages__option[aria-current="page"]');
    selected?.focus({ preventScroll: true });
    const status = main.querySelector('.clendo-packages__status');
    if (status) status.textContent = selected?.textContent.trim() || '';
  } catch (error) {
    if (error.name !== 'AbortError' && request === generation) location.assign(url);
  } finally {
    if (request === generation) {
      pending = null;
      main.removeAttribute('aria-busy');
      forms.forEach((form, index) => { form.inert = previousInert[index]; originalInert.delete(form); });
    }
  }
});

window.addEventListener('popstate', () => {
  if (document.querySelector('.clendo-packages')) location.reload();
});
